const ITEMS = [
  "No Venom Needed ~ Just Pure Pressure",
  "Official ASCAP® Member",
  "Est. 2026",
  "Cold-Blooded Precision",
  "Unapologetic Sound",
  "Artist-First Deals",
  "Mix · Master · Release",
  "DGE: Cold-Blooded Records LLC™",
];

export const MarqueeBanner = () => {
  const row = (
    <div className="flex items-center shrink-0">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-ice/60 px-8">
            {item}
          </span>
          <span className="text-venom text-xs" aria-hidden="true">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="relative border-y border-white/8 bg-charcoal/60 py-4 overflow-hidden"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  );
};
